import { t } from '@lingui/macro'
import React from 'react'
import { IAccount } from 'shopify-payment-core'

import { Brick } from '../atoms/Brick'
import { i18n } from '../i18n'
import { GatewaySetup } from '../molecules/GatewaySetup'
import { InstallGatewayButton } from '../molecules/InstallGatewayButton'

interface IProps {
  account: IAccount
}

export const AccountGateway: React.FC<IProps> = ({ account }) => {
  return (
    <Brick title={i18n._(t`Nastavení Shopify brány`)}>
      <GatewaySetup account={account} />
      <br />
      <InstallGatewayButton account={account} />
    </Brick>
  )
}
